import React, { useContext, useEffect, useState } from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import { Grid } from "@material-ui/core";
import order from "@api/order";
import { MarketContext } from "@context/MarketContext";
import { StatsContext } from "@context/statsContext";
import PriceFormat from "@components/PriceFormat";
import { useParams } from "react-router-dom";
import Typography from "@components/Typography";
import TransactionsListComponent from "../RecentTransactionsList/TransactionsListComponent";
import clsx from "clsx";
import { orderBookTime } from "@core/utils/IntervalApiTime";
import { useRangerOptional } from "@context/rangerContext";

const ColumnRecentTransactionsList = ({ itemsNumber, template }) => {
  const classes = useStyles();
  const market = useContext(MarketContext);
  const { statsState } = useContext(StatsContext);
  const { currencyName } = useParams();
  const ranger = useRangerOptional();
  const useWs = Boolean(ranger?.enabled);
  const statItem = statsState?.stats[currencyName?.replace("-", "_")];
  const dayClose = statItem?.dayClose;

  const ListItemNumber = itemsNumber || 10;

  const [state, setState] = useState({
    sells: [],
    buys: [],
    is_fetch: false,
  });

  useEffect(() => {
    if (!useWs || !currencyName || !ranger?.subscribeMarket) return undefined;
    ranger.subscribeMarket(currencyName);
    return () => ranger.unsubscribeMarket?.();
  }, [useWs, currencyName, ranger?.subscribeMarket, ranger?.unsubscribeMarket]);

  useEffect(() => {
    if (useWs && ranger?.connected) {
      setState({
        sells: ranger.depth?.sells || [],
        buys: ranger.depth?.buys || [],
        is_fetch: Boolean(ranger.depth?.is_fetch),
      });
      return undefined;
    }

    let timerToClear = null;
    (function fetch() {
      order
        .getMarketOrderBook1({
          params: {
            market: currencyName?.replace("-", "_"),
          },
        })
        .then((data) => {
          setState((prevState) => ({
            ...prevState,
            sells: data.content.sells,
            buys: data.content.buys,
            is_fetch: true,
          }));
        })
        .catch((data) => {
          console.log(data);
        });

      timerToClear = setTimeout(fetch, orderBookTime * 1000);
    })();

    return () => clearTimeout(timerToClear);
  }, [
    currencyName,
    market.forceUpdate,
    useWs,
    ranger?.connected,
    ranger?.depth,
  ]);

  const checkColor = (price) => {
    if (price > dayClose) {
      return "primary.tint90";
    } else if (price < dayClose) {
      return "red2.main";
    } else {
      return "";
    }
  };
  return (
    <div
      className={clsx(
        classes.Contentcontainer,
        template === 2 ? classes.template2Container : classes.template3Container
      )}
      justify="space-evenly"
    >
      <div style={{ minHeight: `calc(${(ListItemNumber + 2) * 22}px)` }}>
        <TransactionsListComponent
          orderBookLayout="column"
          reverse={true}
          items={state.sells?.filter((item, index) => index < ListItemNumber)}
          is_fetch={state.is_fetch}
          type="sell"
          currencyName={currencyName}
        />
      </div>

      <div
        className={classes.lastDealContainer}
        {...{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}
      >
        <Grid item>
          <Typography
            variant="sm"
            isBold
            color={checkColor(statItem?.unitPrice)}
          >
            {<PriceFormat price={statItem?.unitPrice} />}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="3xs">{__t("The Last Deal")}</Typography>
        </Grid>
      </div>

      <div style={{ minHeight: `calc(${(ListItemNumber + 1) * 22}px)` }}>
        <TransactionsListComponent
          orderBookLayout="column"
          items={state?.buys?.filter((item, index) => index < ListItemNumber)}
          is_fetch={state.is_fetch}
          type="buy"
          currencyName={currencyName}
        />
      </div>
    </div>
  );
};

export default ColumnRecentTransactionsList;
